import { z } from "zod";

const LogSchema = z.object({
  id: z.number(),
  createdAt: z.string(),
  user: z.object({ firstName: z.string(), lastName: z.string() }),
  aiAnswer: z.enum(["yes", "no", "na"]),
  userAnswer: z.enum(["yes", "no", "na"]),
  currentMemoContent: z.string(),
  state: z.enum(["unresolved", "resolved"]),
  criterion: z
    .object({
      id: z.number(),
      name: z.string(),
      context: z.string()
    })
    .nullable()
});

export type Log = z.infer<typeof LogSchema>;

export const CriteriaAnswerChangeLogResponseSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
    projectChapters: z.array(
      z.object({
        id: z.number(),
        projectTemplateChapter: z
          .object({
            name: z.string()
          })
          .nullable(),
        ProjectCriterionAnswerLog: z.array(LogSchema)
      })
    )
  })
);
